import styled, { css } from "styled-components";

interface MainTemplateStyleProps {
  $padding?: boolean;
  $floatButton?: boolean;
  $navBar?: boolean;
  $gap?: number;
}

export const MainTemplate = styled.div<MainTemplateStyleProps>`
  display: grid;
  width: 100vw;
  height: 100vh;
  background: ${(props) => props.theme.colors.mainBg};
  grid-template-rows: 80px auto;

  ${(props) =>
    props.$navBar === true &&
    css`
      grid-template-rows: 80px auto 100px;
    `}

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    grid-template-rows: 56px calc(100vh - 56px);

    ${(props) =>
      props.$navBar === true &&
      css`
        grid-template-rows: 56px auto 65px;
      `}
  }

  // 모바일 가로 모드 대응
  @media (max-height: 500px) and (orientation: landscape) {
    grid-template-rows: 56px auto;
    height: auto;

    ${(props) =>
      props.$navBar === true &&
      css`
        grid-template-rows: 56px auto 65px;
      `}
  }
`;

export const MainContentBox = styled.section<MainTemplateStyleProps>`
  position: relative;
  display: grid;
  width: 100vw;
  height: auto;
  /* min-height: calc(100vh - 180px); */
  padding: ${(props) => (props.$padding === true ? "24px" : 0)};
  grid-template-columns: repeat(2, 1fr);
  gap: ${(props) => props.$gap}px;

  .padding-content {
    display: flex;
    padding: 16px 16px 26px;
    flex-direction: column;
    gap: 30px;
  }

  ${(props) =>
    props.$floatButton === true &&
    css`
      padding-bottom: 84px;
    `}

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    overflow-y: auto;
    display: flex;
    padding: ${(props) => (props.$padding === true ? "26px 16px" : 0)};
    height: ${(props) =>
      props.$navBar ? "calc(100vh - 121px)" : "calc(100vh - 56px)"};
    flex-direction: column;

    ${(props) =>
      props.$floatButton === true &&
      css`
        padding-bottom: 92px;
      `}
  }

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: ${(props) => (props.$padding === true ? "26px 16px" : 0)};
    height: auto;
    // min-height: calc(100vh - 56px);
  }
`;
